export const WEBSITE_ENV = "production";
export const SITE_URL = "https://client.youshow.org/";
export const ADMIN_URL = "https://admin.youshow.org/pwa2/";
export const API_URL = "https://admin.youshow.org:8082/client-panel/";
export const PWA_URL = "https://app.youshow.org/";
export const LANDING_PAGE_URL = "http://youshow.org";
export const REFERRAL_URL = LANDING_PAGE_URL + "?r=";
export const FACEBOOK_APP_ID = 893232658138723;
export const CDN_URL = "https://cdn.youshow.org/";
export const ASSETS_PATH = CDN_URL + "pwa-admin";
export const VIDEOS_PATH = CDN_URL + "videos";
export const PUBLICIDADES_PATH = CDN_URL + "publicidades";
export const LOGOS_PATH = CDN_URL + "logos";
export const LANGUAGE = "en";
export const PLAN_LIST_URL = "https://client.youshow.org/update-billing-info/plans";
export const STRIPE_KEY = "pk_live_FeU72eWyvgTHI5ShMou0PH5Q002IieOm7N";
export const GOOGLE_API_KEY = "AIzaSyC1yaV2qAQ4HFDCCDnZsd9eCUCEzoQAgyA";
export const MICRO_LANDING_URL = "https://admin.youshow.org/pwa2/microlanding"
export const DEBOUNCE_API_URL = "https://api.debounce.io/v1/";
export const DEBOUNCE_API_KEY  = "610a2c86d05e6";